import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-fast_forward",
  "use": "icon-fast_forward-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol viewBox=\"0 0 48 48\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-fast_forward\"><path d=\"M6.73856 34.6153V13.3847L22.1538 24L6.73856 34.6153ZM25.877 34.6153V13.3847L41.2922 24L25.877 34.6153ZM9.00776 30.2693L18.1924 24L9.00776 17.7116V30.2693ZM28.1461 30.2693L37.3308 24L28.1461 17.7116V30.2693Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol